var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('partner-products-section',{attrs:{"title":_vm.$t('Most ordered'),"products":_vm.products,"loading":_vm.loading,"skeleton":false}})}
var staticRenderFns = []

export { render, staticRenderFns }